import { MessageType, AgentDumpLogMessageType } from 'app/modules/remote-control-ng/definitions';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';

/**
 * PC_AGENT_DUMP_LOG MessageType
 * Sends a request to the agent to download only the device logs included in the provided categories
 * @param {AgentDumpLogMessageType} requestType by default PC_AGENT_DUMP_LOG_REQUEST
 * @param {Array<string>} requestCategories optional list of categories to download
 */
export class AgentDumpLogMessage extends BaseMessage {
    private dumpType: AgentDumpLogMessageType;
    public categories: Array<string>;

    constructor(requestType?: AgentDumpLogMessageType, requestCategories?: Array<string>) {
        super();
        this.dumpType = requestType || AgentDumpLogMessageType.PC_AGENT_DUMP_LOG_REQUEST;
        if (requestCategories != null) {
            this.categories = requestCategories;
        }
        this.header.command = MessageType.PC_AGENT_DUMP_LOG;
    }

    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(this.dumpType);
        if (this.categories?.length >= 0) {
            // Write the length of the categories array
            buffer.writeInt32BE(this.categories.length);

            this.categories.forEach(category => {
                //Add each requested category to the message
                buffer.writeStringLE(category);
            });

        } else {
            buffer.writeStringLE('');
        }
    }

    public deserializeBody(buffer: MemoryBuffer): void {
        this.dumpType = buffer.readUInt8();

        // We are only interested in the dumpType .
        // PC_AGENT_DUMP_LOG_REQUEST and MC_DEBUG_REPORT_BY_LIST are NOT handled in client side
        if (this.dumpType == AgentDumpLogMessageType.MC_DEBUG_REPORT_QUERY) {
            const numberOfCategories = buffer.readInt32BE();

            // Fill the list of categories
            this.categories = new Array(numberOfCategories);
            for (var i = 0; i < numberOfCategories; i++) {
                const category = buffer.readString();
                this.categories[i] = category;
            }
        }
    }
}
